import { PaymentMethod } from "../../../api/settlement";
import { SettlementDailyRevenueResponse } from "../../../api/settlement-daily";

export const revenueHeaders = [
  { header: "현금 매출", method: PaymentMethod.CASH },
  { header: "계좌 매출", method: PaymentMethod.BANK_TRANSFER },
  { header: "카드 매출", method: PaymentMethod.CARD },
  { header: "포인트(무료) 매출", method: PaymentMethod.POINTS },
  { header: "래빗 매출", method: PaymentMethod.SEED },
];

export const getMethodData = (
  method: PaymentMethod,
  dailyRevenue?: SettlementDailyRevenueResponse
) => {
  return dailyRevenue?.paymentMethodRevenues.find((p) => p.method === method);
};

export const getMethodRate = (
  method: PaymentMethod,
  dailyRevenue?: SettlementDailyRevenueResponse
) => {
  if (!dailyRevenue || !getMethodData(method, dailyRevenue)) return "0.00";
  const tournament =
    getMethodData(method, dailyRevenue)?.tournamentRevenue || 0;
  const other = getMethodData(method, dailyRevenue)?.otherRevenue || 0;
  const total = tournament + other;

  if (!total) return "0.00";

  const rate = (total / (dailyRevenue?.totalRevenue || 0)) * 100;
  return rate.toFixed(2);
};
